/**
 * TaskPriorityBadge Component
 *
 * Displays priority badge for tasks
 *
 * @module components/tasks/shared/TaskPriorityBadge
 */

import React from 'react';
import { Badge } from 'react-bootstrap';
import PropTypes from 'prop-types';

/**
 * TaskPriorityBadge Component
 *
 * @param {Object} props
 * @param {string} props.priority - Priority level: 'high', 'medium', 'low'
 * @param {string} props.className - Additional CSS classes
 */
const TaskPriorityBadge = ({ priority, className = '' }) => {
  const getPriorityConfig = (priority) => {
    switch (priority) {
      case 'urgent':
        return {
          variant: 'dark',
          text: 'Urgente',
          icon: 'bi-exclamation-triangle-fill'
        };
      case 'high':
        return {
          variant: 'danger',
          text: 'Alta',
          icon: 'bi-exclamation-circle-fill'
        };
      case 'medium':
        return {
          variant: 'warning',
          text: 'Media',
          icon: 'bi-dash-circle-fill'
        };
      case 'low':
        return {
          variant: 'secondary',
          text: 'Baja',
          icon: 'bi-arrow-down-circle-fill'
        };
      default:
        return {
          variant: 'secondary',
          text: 'Sin prioridad',
          icon: 'bi-circle'
        };
    }
  };

  const config = getPriorityConfig(priority);

  return (
    <Badge
      bg={config.variant}
      className={`task-priority-badge d-inline-flex align-items-center gap-1 ${className}`}
    >
      <i className={`bi ${config.icon}`} style={{ fontSize: '0.875rem' }}></i>
      <span>{config.text}</span>
    </Badge>
  );
};

TaskPriorityBadge.propTypes = {
  priority: PropTypes.oneOf(['urgent', 'high', 'medium', 'low']).isRequired,
  className: PropTypes.string
};

export default TaskPriorityBadge;
